"use client";

import { useEffect } from "react";

interface LegacyBlogRedirectProps {
  href: string;
}

function LegacyBlogRedirect({ href }: LegacyBlogRedirectProps) {
  useEffect(() => {
    window.location.replace(href);
  }, [href]);

  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <div className="text-center">
        <div className="mb-4 text-lg text-gray-700">블로그 페이지로 이동 중입니다...</div>
        <div className="text-sm text-gray-500">
          자동으로 이동되지 않는다면{" "}
          <a href={href} className="text-blue-600 underline hover:text-blue-800">
            여기를 클릭
          </a>
          해주세요.
        </div>
      </div>
    </div>
  );
}

export default LegacyBlogRedirect;
